import { useMemo, useCallback, useEffect } from 'react'

function useAsyncEffect(asyncCallback, deps = []) {
  const [promise, resolve, reject] = useMemo(() => {
    let resolve, reject
    const promise = new Promise((resolveFn, rejectFn) => {
      resolve = resolveFn
      reject = rejectFn
    })

    return [promise, resolve, reject]
  }, deps)

  const memoizedCallback = useCallback(async () => await asyncCallback(), deps)

  useEffect(() => {
    // asyncCallback must return a Promise, so we can .then() it here
    memoizedCallback().then(resolve, reject)
  }, [memoizedCallback, resolve, reject])

  return promise
}

export default function useCsrfToken() {
  const csrfPromise = useAsyncEffect(async () => {
    const response = await fetch('/csrf_meta.json')

    if (response.status !== 200) {
      throw new Error(`CSRF endpoint returned HTTP status ${response.status}`)
    }

    const { token } = await response.json()

    if (typeof token !== 'string') {
      throw new Error('CSRF endpoint did not return a token')
    }
    return token
  })

  return csrfPromise
}
